export default __webpack_public_path__ + "static/media/banklogo.ce6e8d93.png";